export const getVariantIdentifier = (variant: any): string | undefined => {
  if (!variant || typeof variant !== "object") {
    return undefined
  }

  const candidates = [
    variant.id,
    variant._id,
    variant.variantId,
    variant.sku,
  ]

  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.length > 0) {
      return candidate
    }
    if (typeof candidate === "number" && Number.isFinite(candidate)) {
      return String(candidate)
    }
    if (
      candidate &&
      typeof candidate === "object" &&
      typeof (candidate as any).toString === "function"
    ) {
      const strValue = (candidate as any).toString()
      if (typeof strValue === "string" && strValue !== "[object Object]") {
        return strValue
      }
    }
  }

  return undefined
}
